import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { AtokuService } from '../services/atoku.service';
import { AtokuStatusPillConfig, getEntryStatusPill } from '../common/atoku-status-pill.util';

interface MockAccessEntryRow {
    id: string;
    userName: string;
    userEmail: string;
    localDateTime: string;
    eventType: 'entry' | 'exit';
    doorName: string;
    status: 'granted' | 'denied';
}

@Component({
    selector: 'app-atoku-access-entries',
    templateUrl: './atoku-access-entries.component.html',
    styleUrls: ['./atoku-access-entries.component.scss']
})
export class AtokuAccessEntriesComponent implements AfterViewInit {
    displayedColumns: string[] = ['userName', 'userEmail', 'localDateTime', 'eventType', 'doorName', 'status'];
    dataSource = new MatTableDataSource<MockAccessEntryRow>([]);

    @ViewChild(MatPaginator) paginator!: MatPaginator;

    constructor(private atokuService: AtokuService) {
        this.dataSource.filterPredicate = (row, filter) =>
            [row.userName, row.userEmail, row.localDateTime, row.eventType, row.doorName, row.status]
                .join(' ')
                .toLowerCase()
                .includes(filter);
        this.loadEntries();
    }

    ngAfterViewInit(): void {
        this.dataSource.paginator = this.paginator;
    }

    applyTableFilter(event: Event): void {
        const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
        this.dataSource.filter = filterValue;
        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }

    getStatusPill(row: MockAccessEntryRow): AtokuStatusPillConfig {
        return getEntryStatusPill(row.status);
    }

    private loadEntries(): void {
        this.atokuService.checkSiteEntries()
            .subscribe(response => {
                this.dataSource.data = (response.items ?? []).map(item => {
                    const raw = item as Record<string, unknown>;
                    const userName = String(raw['user_name'] ?? raw['userName'] ?? '').trim();
                    return {
                        id: String(raw['id'] ?? ''),
                        userName,
                        userEmail: String(raw['user_email'] ?? raw['userEmail'] ?? ''),
                        localDateTime: String(raw['local_date_time'] ?? raw['localDateTime'] ?? ''),
                        eventType: (String(raw['event_type'] ?? raw['eventType'] ?? 'entry').toLowerCase() === 'exit' ? 'exit' : 'entry'),
                        doorName: String(raw['door_name'] ?? raw['doorName'] ?? ''),
                        status: (String(raw['status'] ?? 'granted').toLowerCase() === 'denied' ? 'denied' : 'granted')
                    };
                });
            });
    }
}
